module.exports = __webpack_public_path__ + "img/phase3_img03.9ac925ff.png";